import React from "react";
import { useState, useEffect } from "react";
import instance from "../../services/ApiServices";
import { motion } from "motion/react";

const Hero = () => {
  const endpoint = "slider";
  // const sliderdata = "./heroimage.jpg";

  const [slider, setSlider] = useState("");

  useEffect(() => {
    instance.get(endpoint).then((res) => {
      const datarcd = res.data[0];
      setSlider(datarcd.image);

      // console.log("My Image:" + JSON.stringify(datarcd));

      // console.log("Gallery Items :"+JSON.stringify(galleryitems));
    });
  }, []);

  // console.log("My Image:" + JSON.stringify(Slider));

  return (
    <div
      id="home"
      className="left-0 top-0 z-20"
    >
      <motion.img
        initial={{ x: -100, opacity: 0 }}
        whileInView={{
          x: 0,
          opacity: 1,
          transition: {
            delay: 0.4,
            x: { type: "tween", stiffness: 60 },
            opacity: { duration: 0.6 },
            ease: "easeIn",
          },
        }}
        src={slider}
        alt=""
        className="h-screen w-full  object-cover "
      />
    </div>
  );
};

export default Hero;
